import ReactDOM from 'react-dom'
import React, { FunctionComponent } from 'react'
import { useRegisterManager } from '../../../../ng-compat/hooks'
import {
  isCashDiscountingPaymentOption,
  isCashPaymentOption,
  isGiftCardPaymentOption,
  isIntegratedPaymentOption,
  isLSPayEcomRefundPaymentOption,
  isLSPayPaymentOption,
  isSwiperPaymentOption,
  PaymentOptions,
  SalePayment,
} from './types'
import { Cash } from './CashModal'
import { SwiperPayment } from './SwiperPayment'
import { LsPay } from './LsPay'
import { IntegratedPayment } from './IntegratedPayment'
import { GiftCard } from './GiftCard'
import { LsPayEcomRefund } from './LsPayEcomRefund'
import { CashDiscounting } from './CashDiscounting'

type Props = {
  onClose: () => void
  onSuccess: (result: SalePayment) => void
  paymentOptions: PaymentOptions
}

export const PaymentModal: FunctionComponent<Props> = ({
  paymentOptions,
  onClose,
  onSuccess,
}) => {
  const currencySymbol = useRegisterManager().getActiveOutlet().currency_symbol

  if (!paymentOptions.paymentType) {
    return null
  }

  switch (paymentOptions.paymentModalType) {
    case 'cash':
      if (isCashPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <Cash
            paymentOptions={paymentOptions}
            onSuccess={onSuccess}
            onClose={onClose}
            currencySymbol={currencySymbol}
          />,
          document.body
        )
      }
      break
    case 'cashDiscounting':
      if (isCashDiscountingPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <CashDiscounting
            paymentOptions={paymentOptions}
            onSuccess={onSuccess}
            onClose={onClose}
          />,
          document.body
        )
      }
      break
    case 'integrated':
      if (isIntegratedPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <IntegratedPayment
            paymentOptions={paymentOptions}
            onSuccess={onSuccess}
            onClose={onClose}
          />,
          document.body
        )
      }
      break
    case 'giftCard':
      if (isGiftCardPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <GiftCard
            paymentOptions={paymentOptions}
            onSuccess={onSuccess}
            onClose={onClose}
          />,
          document.body
        )
      }
      break
    case 'lsPay':
      if (isLSPayPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <LsPay
            paymentOptions={paymentOptions}
            onClose={onClose}
            onSuccess={onSuccess}
          />,
          document.body
        )
      }
      break

    case 'lsPayEcomRefund':
      if (isLSPayEcomRefundPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <LsPayEcomRefund
            paymentOption={paymentOptions}
            onClose={onClose}
            onSuccess={onSuccess}
          />,
          document.body
        )
      }
      break
    case 'lspayRecovery':
      return null
    case 'partialAuth':
      return null
    case 'partialPayment':
      return null
    case 'swiper':
      if (isSwiperPaymentOption(paymentOptions)) {
        return ReactDOM.createPortal(
          <SwiperPayment
            paymentOptions={paymentOptions}
            onClose={onClose}
            onSuccess={onSuccess}
          />,
          document.body
        )
      }
      break
    default: {
      // Some default payment type should not have modal
      return null
    }
  }
}
